import { Box, TextField, Typography } from '@mui/material'
import { ItemScanError, SnackbarSeverity } from 'constant'
import { OrderContext } from 'contexts/OrderContextProvider'
import { SnackContext } from 'contexts/SnackContextProvider'
import React, { useContext, useEffect, useState } from 'react'

const ProductListSearchBar = () => {
  const { handleScanProduct, itemSearchError, setItemSearchError, inputRef } =
    useContext(OrderContext)
  const [itemUpc, setItemUpc] = useState('')
  const { snackbarAttributes, handleOpenSnackbar, handleCloseSnackbar } =
    useContext(SnackContext)
  const getSnackMessage = (itemSearchError: string) => {
    switch (itemSearchError) {
      case ItemScanError.ExceedMax:
        return 'Item input has exceeded the maximum value!'
      case ItemScanError.InvalidUpc:
        return 'Wrong upc input, cannot find item!'
      case ItemScanError.NoInventory:
        return 'Not enough inventory available!'
      default:
        break
    }
  }
  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleScanProduct(itemUpc, setItemUpc)
    }
  }
  useEffect(() => {
    if (itemSearchError) {
      handleOpenSnackbar(
        SnackbarSeverity.Error,
        getSnackMessage(itemSearchError) || 'Unexpected error occurred'
      )
    }
  }, [itemSearchError])
  return (
    <Box
      sx={{
        backgroundColor: '#dfe4eb',
        padding: '5px 10px',
        '& input': {
          backgroundColor: '#fff'
        }
      }}
      onKeyDown={handleKeyDown}
    >
      <Typography>Item:</Typography>
      <TextField
        fullWidth
        autoFocus
        inputRef={inputRef}
        size='small'
        value={itemUpc}
        error={!!itemSearchError}
        disabled={snackbarAttributes.open}
        onChange={e => {
          if (itemSearchError !== '') {
            const oldValue = itemUpc
            setItemUpc(e.target.value.substring(oldValue.length))
            setItemSearchError('')
          } else {
            setItemUpc(e.target.value)
          }
          handleCloseSnackbar()
        }}
      />
    </Box>
  )
}

export default ProductListSearchBar
